import Markdown from 'components/Shared/Markdown';
import { ToolTipDialog } from 'components/Shared/ToolTip/themes/BGH-RD3';
import { useSelector } from 'react-redux';
import { NO_ELEMENT } from 'utils';
import { savingsTitle, savingsExplanation, savingsAmount } from '../../selectors';
import styles from './style.scss';
import { isMobile } from 'components/Shared/responsive';
import cn from 'classnames';

const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

export const Savings = () => {
  const title = useSelector(savingsTitle);
  const tooltip = useSelector(savingsExplanation);
  const savings = useSelector(savingsAmount);
  const mobileLayout = useSelector(isMobile);

  if (!title || !savings) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.savingsContainer}>
      <strong>
        {title}
        {tooltip && (
          <span onClick={stopPropagation}>
            <ToolTipDialog
              className={styles.tooltip}
              contentClassName={cn(
                mobileLayout ? styles.tooltipContentMobile : styles.tooltipContent
              )}
              position={'left'}
              text={<Markdown content={tooltip} tag="div" />}
            />
          </span>
        )}
      </strong>

      <span className={styles.savings}>{savings}</span>
    </div>
  );
};
